import * as React from 'react';
import IBookmarkListItem from './interfaces/bookmarkListItem';
import { formatDate } from '../../modules/sidebarMostVisited';
import { BookmarkService } from '../../services/bookmarkService';
import { sendEvent } from '../../modules/helpers/Analytics';
/**
 *      title: string;
        pageUrl: string;
        id: string;
        categoryName: string;
        pageType: string;
        documentMetaType?: string;
        created?: string;
 */
export default class BookmarkListItem extends React.Component<IBookmarkListItem, null> {
    bookmarkService: BookmarkService;

    constructor(props) {
        super(props);

        this.state = {
            isSelectedFavorite: props.bookmark.isSelectedFavorite, // Initialize state from props
        };

        this.bookmarkService = new BookmarkService();
    }

    componentDidUpdate(prevProps: IBookmarkListItem) {
        if (
            prevProps.bookmark.id !== this.props.bookmark.id ||
            prevProps.bookmark.isSelectedFavorite !== this.props.bookmark.isSelectedFavorite
        ) {
            this.setState({ isSelectedFavorite: this.props.bookmark.isSelectedFavorite });
        }
    }

    toggleFavorite = () => {
        const { bookmark, onFavoriteChange } = this.props;
        const newFavoriteStatus = !this.state.isSelectedFavorite;

        // Call the service to update the favorite status
        this.bookmarkService.togglePinnedBookmark(
            bookmark.id,
            newFavoriteStatus,
            () => {
                this.setState({ isSelectedFavorite: newFavoriteStatus }, () => {
                    if (onFavoriteChange) {
                        onFavoriteChange(bookmark.id, newFavoriteStatus);
                        
                    }
                });
            },
            () => {
                console.error("Failed to toggle favorite status.");
            }
        );
    };

    selectPinnedBookmark = () => {
        const { bookmark, onFavoriteChange } = this.props;
        const newFavoriteStatus = true;

        // Call the service to update the favorite status
        this.bookmarkService.selectPinnedBookmark(
            bookmark.id,
            () => {
                this.setState({ isSelectedFavorite: newFavoriteStatus }, () => {
                    if (onFavoriteChange) {
                        onFavoriteChange(bookmark.id, true);
                    }
                    window.dispatchEvent(new Event("OnPinnedBookmarkChanged", { bubbles: false, cancelable: false }))
                });
            },
            () => {
                console.error("Failed to toggle favorite status.");
            }
        );
    };

    unSelectPinnedBookmark = () => {
        const { bookmark, onFavoriteChange } = this.props;
        const newFavoriteStatus = false;

        // Call the service to update the favorite status
        this.bookmarkService.unSelectPinnedBookmark(
            bookmark.id,
            () => {
                this.setState({ isSelectedFavorite: newFavoriteStatus }, () => {
                    if (onFavoriteChange) {
                        onFavoriteChange(bookmark.id, false);
                    }
                    window.dispatchEvent(new Event("OnPinnedBookmarkChanged", { bubbles: false, cancelable: false }))
                });
            },
            () => {
                console.error("Failed to toggle favorite status.");
            }
        );
    };

    render() {
        const { bookmark, onButtonClick, onLinkClick } = this.props;
        const { isSelectedFavorite } = this.state;
        return (
            <li key={bookmark.id} data-id={bookmark.id}>
                <a className="notifications__notifications-item" href={bookmark.pageUrl}>
                    <div className="top">
                        {bookmark.documentMetaType ? (
                            <span className="tag">{bookmark.documentMetaType}</span>
                        ) : ""}
                     </div>
                    <div className="bottom">
                        <span className="notifications__link-item">{bookmark.title}</span>

                        <div className="buttons">
                            <button className={`notification__favourite-toggle ${isSelectedFavorite ? "notification__favourite-toggled" : ""}`}
                                title={isSelectedFavorite ? "Ta bort nål" : "Nåla på startsidan"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isSelectedFavorite) {
                                        this.unSelectPinnedBookmark(); // Call this when it is already a favorite
                                    } else {
                                        sendEvent('pinBookmark', undefined, { pageTitle: bookmark.title, pageURL: bookmark.pageUrl })
                                        this.selectPinnedBookmark(); // Call this when it's not yet a favorite
                                    }
                                }}>{isSelectedFavorite ? "Ta bort nål" : "Nåla på startsidan"}</button>

                            <button className="coverages__edit-button" title='Redigera' onClick={(event) => onButtonClick(event)}><span>Redigera</span></button>
                        </div>
                    </div>
                </a>
            </li>
        );
    }
}